<div class="conta-certa">
  <i class="btn-close icon-edponline-Bop-071" *ngIf="data.showClose" data-modal="dismiss()"
    (click)="closeModal(false)"  aria-hidden="true"></i>
  <div class="left-side">
    <div class="header-container">
      <div class="d-none d-lg-block">
        <h3 class="header">{{'pt.edp.edponline.endpoint.conta.certa.button' | translate}} <span
            class="highlight-red">{{ 'pt.edp.edponline.endpoint.conta.certa.title' | translate }}</span></h3>
      </div>
      <div class="d-lg-none title-container">
        <div class="header">{{'pt.edp.edponline.endpoint.conta.certa.button' | translate}}</div>
        <div class="header highlight-red">{{ 'pt.edp.edponline.endpoint.conta.certa.title' | translate }}</div>
      </div>
      <div class="values-container d-none d-sm-flex ">
        <div class="monthly-payment">
          <p class="title">{{'pt.edp.edponline.conta.certa.label.monthly.payment' | translate}} {{ 'ChangeTariffFeature.Atual' | translate }}</p>
          <p class="amount">{{ contaCertaInfo?.monthlyPayment }}€</p>
          <p class="subtitle">&nbsp;</p>
        </div>
        <div class="account-adjustment">
          <p class="title">{{'pt.edp.edponline.conta.certa.label.last.payment' | translate}}
            <span class="highlight-red">{{ payOrReceive4LastPayment }}</span></p>
          <p class="amount">{{ contaCertaInfo?.lastMonthPayment }}€</p>
          <p class="account-adjustment-subtitle">{{'pt.edp.edponline.conta.certa.label.last.payment.forecast' | translate}}</p>
        </div>
      </div>
      <div class="values-container d-flex d-sm-none">
        <div class="monthly-payment">
          <p class="title">{{'pt.edp.edponline.conta.certa.label.monthly.payment' | translate}} <br>
          {{ 'ChangeTariffFeature.Atual' | translate }}</p>
          <p class="amount">{{ contaCertaInfo?.monthlyPayment }}€</p>
        </div>
        <div class="account-adjustment">
          <p class="title">{{'pt.edp.edponline.conta.certa.label.last.payment' | translate}} <br>
            <span class="highlight-red">{{ payOrReceive4LastPayment }}</span></p>
          <p class="amount">{{ contaCertaInfo?.lastMonthPayment }}€</p>
        </div>
        <div class="account-adjustment-subtitle-mobi-size">
          <p class="account-adjustment-subtitle">{{'pt.edp.edponline.conta.certa.label.last.payment.forecast' | translate}}</p>
        </div>
      </div>
    </div>
    <div class="chart-container">
      <div id="conta-certa-legend" class="legend"></div>
      <div id="conta-certa-chart" class="chart"></div>
    </div>

  </div>
  <div class="right-side">
    <div class="title-container">
      <p class="title">{{'pt.edp.edponline.conta.certa.label.new.payment.sugestion' |translate: {'floatableValue': floatableValue} }}
        <span class="font-weight-bold">{{ contaCertaInfo?.sugestedMonthlyPayment }}€ </span>(*).</p>
      <p class="subtitle">(*) {{'pt.edp.edponline.conta.certa.label.new.payment.sugestion.star' | translate}}</p>
    </div>
    <div class="sugested-values-container edp-scroll-disabled">
      <div class="d-flex">
        <a *ngFor="let item of multipleListValues" (click)="useSugestedValue(item)">
          <div class="sugested-value d-flex justify-content-center align-items-center"
            [ngClass]="{'circle-selected': item === highLightedValue}"><span>{{item}}€</span></div>
        </a>
        <a (click)="useOtherValue()">
          <div class="other-value d-flex justify-content-center align-items-center"
            [ngClass]="{'circle-selected': highLightedValue === -1}">
            <span>{{'pt.edp.edponline.conta.certa.label.another' | translate}}</span></div>
        </a>
      </div>
    </div>
    <form [formGroup]="monthlyPaymentForm" class="d-flex flex-column">
      <div class="monthly-payment-form-container" *ngIf="showInput">
        <label
          class="title">{{'pt.edp.edponline.conta.certa.label.insert.value.between' |translate: {'minValue': min, 'maxValue': max} }}
        </label>
        <div class="d-flex align-items-center">
          <input type="number" class="form-control" formControlName="newContaCertaValue"
            [ngClass]="{'error': isInvalid()}" (change)="setPayOrReceive($event.target.value)">
          <span class="euro-sign">€</span>
        </div>
      </div>
      <div class="calculated-value-container d-flex align-items-center">
        <div class="calculated-value-title">{{'pt.edp.edponline.conta.certa.label.pay.or.receive' | translate}}
          <span class="font-weight-bold">{{ payOrReceive | lowercase }}</span> {{'pt.edp.edponline.conta.certa.label.pay.or.receive.about' | translate}}:
        </div>
        <div class="calculated-value">{{ lastMonthPaymentBasedOnChoice }}€</div>
      </div>
      <div class="warning font-weight-bold" *ngIf="messageShow" [innerHTML]="'pt.edp.edponline.conta.certa.modal.warning' | translate: {'dateToShow': dateToShow}"></div>

      <div class="d-flex justify-content-center justify-content-md-center justify-content-lg-end button-final">
        <button impersonateDisable class="btn edp-btn-primary" type="button" [disabled]="buttonDisabled" (click)="submitNewValue()">{{ buttonMessage }}</button>
      </div>
    </form>
    <edp-loader *ngIf="loading" [size]="'md'" [position]="'full'" ></edp-loader>
  </div>